/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Discount_CodeInputs */

const en_directory_submit_discount_code = /** @type {(inputs: Directory_Submit_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discount code (optional)`)
};

const zh_directory_submit_discount_code = /** @type {(inputs: Directory_Submit_Discount_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`折扣码（选填）`)
};

/**
* | output |
* | --- |
* | "Discount code (optional)" |
*
* @param {Directory_Submit_Discount_CodeInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_discount_code = /** @type {((inputs?: Directory_Submit_Discount_CodeInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Discount_CodeInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_discount_code(inputs)
	return zh_directory_submit_discount_code(inputs)
});
export { directory_submit_discount_code as "directory.submit.discount_code" }